
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    const addedRoutes = router.getRoutes().filter(r => !r._initial)
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      for (const route of router.getRoutes()) {
        route._initial = true
      }
      for (const route of addedRoutes) {
        router.addRoute(route)
      }
      router.isReady().then(() => {
        // Resolve the current path against the new routes to get updated meta
        const newRoute = router.resolve(router.currentRoute.value.fullPath)
        // Clear old meta values and assign new ones
        for (const key of Object.keys(router.currentRoute.value.meta)) {
          delete router.currentRoute.value.meta[key]
        }
        Object.assign(router.currentRoute.value.meta, newRoute.meta)
      })
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
    for (const route of _router.getRoutes()) {
      route._initial = true
    }
  }
}
import { default as _91_46_46_46slug_93WiuWgQ2g6kkLmqbBd22tJqDDtlpLsVYNP2yiYz__x6YMeta } from "/usr/src/nuxt-app/pages/[...slug].vue?macro=true";
import { default as _91slug_93oqivvInLZgGsfGxR5B8CM7Jt1OvlqgQnBdD74l_45eDcMMeta } from "/usr/src/nuxt-app/pages/news/[slug].vue?macro=true";
import { default as _91slug_939RBHGuLf4_PGhDD0Kv94kVVrnx_Pek4YTr2FypTG6NgMeta } from "/usr/src/nuxt-app/pages/event/[slug].vue?macro=true";
import { default as _91slug_93ssgNLNME8cRDI_45v3MQF1YeNTbJleHKlnhSXoxOMnnqMMeta } from "/usr/src/nuxt-app/pages/products/[slug].vue?macro=true";
import { default as _91category_93WWBGRX3n_fjAyNg0vsf4SPbFO5_aQX_45jImV7AzeoFbkMeta } from "/usr/src/nuxt-app/pages/search/[category].vue?macro=true";
import { default as unauthorized_45accessETBjBkLuowXBB3b4MeZVprhLLH2MzIXkO294iErUUToMeta } from "/usr/src/nuxt-app/pages/unauthorized-access.vue?macro=true";
import { default as unauthorized_45regionahzbxm7Lq1ZCLipcD63si4YyGEYQxlR7xPdUlYBMajgMeta } from "/usr/src/nuxt-app/pages/unauthorized-region.vue?macro=true";
import { default as _91id_93uqLl8_djPb_45jS62wEZOXPz07L8h7nlt8zCTCBUT28IoMeta } from "/usr/src/nuxt-app/pages/preview/article/[id].vue?macro=true";
import { default as component_45stub5NatCyIcPyRWR_VP9IPrV2_7eD13VIAMdmbwNW3_454B8Meta } from "/usr/src/nuxt-app/node_modules/nuxt/dist/pages/runtime/component-stub.js?macro=true";
import { default as component_45stub5NatCyIcPyRWR_VP9IPrV2_7eD13VIAMdmbwNW3_454B8 } from "/usr/src/nuxt-app/node_modules/nuxt/dist/pages/runtime/component-stub.js";
export default [
  {
    name: "slug___en",
    path: "/en/:slug(.*)*",
    component: () => import("/usr/src/nuxt-app/pages/[...slug].vue")
  },
  {
    name: "slug___zh-Hans",
    path: "/zh-Hans/:slug(.*)*",
    component: () => import("/usr/src/nuxt-app/pages/[...slug].vue")
  },
  {
    name: "slug___zh-Hant",
    path: "/zh-Hant/:slug(.*)*",
    component: () => import("/usr/src/nuxt-app/pages/[...slug].vue")
  },
  {
    name: "slug___fr",
    path: "/fr/:slug(.*)*",
    component: () => import("/usr/src/nuxt-app/pages/[...slug].vue")
  },
  {
    name: "slug___de",
    path: "/de/:slug(.*)*",
    component: () => import("/usr/src/nuxt-app/pages/[...slug].vue")
  },
  {
    name: "slug___it",
    path: "/it/:slug(.*)*",
    component: () => import("/usr/src/nuxt-app/pages/[...slug].vue")
  },
  {
    name: "slug___ja",
    path: "/ja/:slug(.*)*",
    component: () => import("/usr/src/nuxt-app/pages/[...slug].vue")
  },
  {
    name: "slug___ko",
    path: "/ko/:slug(.*)*",
    component: () => import("/usr/src/nuxt-app/pages/[...slug].vue")
  },
  {
    name: "slug___pt-BR",
    path: "/pt-BR/:slug(.*)*",
    component: () => import("/usr/src/nuxt-app/pages/[...slug].vue")
  },
  {
    name: "slug___ru",
    path: "/ru/:slug(.*)*",
    component: () => import("/usr/src/nuxt-app/pages/[...slug].vue")
  },
  {
    name: "slug___es",
    path: "/es/:slug(.*)*",
    component: () => import("/usr/src/nuxt-app/pages/[...slug].vue")
  },
  {
    name: "news-slug___en",
    path: "/en/news/:slug()",
    component: () => import("/usr/src/nuxt-app/pages/news/[slug].vue")
  },
  {
    name: "news-slug___zh-Hans",
    path: "/zh-Hans/news/:slug()",
    component: () => import("/usr/src/nuxt-app/pages/news/[slug].vue")
  },
  {
    name: "news-slug___zh-Hant",
    path: "/zh-Hant/news/:slug()",
    component: () => import("/usr/src/nuxt-app/pages/news/[slug].vue")
  },
  {
    name: "news-slug___fr",
    path: "/fr/news/:slug()",
    component: () => import("/usr/src/nuxt-app/pages/news/[slug].vue")
  },
  {
    name: "news-slug___de",
    path: "/de/news/:slug()",
    component: () => import("/usr/src/nuxt-app/pages/news/[slug].vue")
  },
  {
    name: "news-slug___it",
    path: "/it/news/:slug()",
    component: () => import("/usr/src/nuxt-app/pages/news/[slug].vue")
  },
  {
    name: "news-slug___ja",
    path: "/ja/news/:slug()",
    component: () => import("/usr/src/nuxt-app/pages/news/[slug].vue")
  },
  {
    name: "news-slug___ko",
    path: "/ko/news/:slug()",
    component: () => import("/usr/src/nuxt-app/pages/news/[slug].vue")
  },
  {
    name: "news-slug___pt-BR",
    path: "/pt-BR/news/:slug()",
    component: () => import("/usr/src/nuxt-app/pages/news/[slug].vue")
  },
  {
    name: "news-slug___ru",
    path: "/ru/news/:slug()",
    component: () => import("/usr/src/nuxt-app/pages/news/[slug].vue")
  },
  {
    name: "news-slug___es",
    path: "/es/news/:slug()",
    component: () => import("/usr/src/nuxt-app/pages/news/[slug].vue")
  },
  {
    name: "event-slug___en",
    path: "/en/event/:slug()",
    component: () => import("/usr/src/nuxt-app/pages/event/[slug].vue")
  },
  {
    name: "event-slug___zh-Hans",
    path: "/zh-Hans/event/:slug()",
    component: () => import("/usr/src/nuxt-app/pages/event/[slug].vue")
  },
  {
    name: "event-slug___zh-Hant",
    path: "/zh-Hant/event/:slug()",
    component: () => import("/usr/src/nuxt-app/pages/event/[slug].vue")
  },
  {
    name: "event-slug___fr",
    path: "/fr/event/:slug()",
    component: () => import("/usr/src/nuxt-app/pages/event/[slug].vue")
  },
  {
    name: "event-slug___de",
    path: "/de/event/:slug()",
    component: () => import("/usr/src/nuxt-app/pages/event/[slug].vue")
  },
  {
    name: "event-slug___it",
    path: "/it/event/:slug()",
    component: () => import("/usr/src/nuxt-app/pages/event/[slug].vue")
  },
  {
    name: "event-slug___ja",
    path: "/ja/event/:slug()",
    component: () => import("/usr/src/nuxt-app/pages/event/[slug].vue")
  },
  {
    name: "event-slug___ko",
    path: "/ko/event/:slug()",
    component: () => import("/usr/src/nuxt-app/pages/event/[slug].vue")
  },
  {
    name: "event-slug___pt-BR",
    path: "/pt-BR/event/:slug()",
    component: () => import("/usr/src/nuxt-app/pages/event/[slug].vue")
  },
  {
    name: "event-slug___ru",
    path: "/ru/event/:slug()",
    component: () => import("/usr/src/nuxt-app/pages/event/[slug].vue")
  },
  {
    name: "event-slug___es",
    path: "/es/event/:slug()",
    component: () => import("/usr/src/nuxt-app/pages/event/[slug].vue")
  },
  {
    name: "products-slug___en",
    path: "/en/products/:slug()",
    component: () => import("/usr/src/nuxt-app/pages/products/[slug].vue")
  },
  {
    name: "products-slug___zh-Hans",
    path: "/zh-Hans/products/:slug()",
    component: () => import("/usr/src/nuxt-app/pages/products/[slug].vue")
  },
  {
    name: "products-slug___zh-Hant",
    path: "/zh-Hant/products/:slug()",
    component: () => import("/usr/src/nuxt-app/pages/products/[slug].vue")
  },
  {
    name: "products-slug___fr",
    path: "/fr/products/:slug()",
    component: () => import("/usr/src/nuxt-app/pages/products/[slug].vue")
  },
  {
    name: "products-slug___de",
    path: "/de/products/:slug()",
    component: () => import("/usr/src/nuxt-app/pages/products/[slug].vue")
  },
  {
    name: "products-slug___it",
    path: "/it/products/:slug()",
    component: () => import("/usr/src/nuxt-app/pages/products/[slug].vue")
  },
  {
    name: "products-slug___ja",
    path: "/ja/products/:slug()",
    component: () => import("/usr/src/nuxt-app/pages/products/[slug].vue")
  },
  {
    name: "products-slug___ko",
    path: "/ko/products/:slug()",
    component: () => import("/usr/src/nuxt-app/pages/products/[slug].vue")
  },
  {
    name: "products-slug___pt-BR",
    path: "/pt-BR/products/:slug()",
    component: () => import("/usr/src/nuxt-app/pages/products/[slug].vue")
  },
  {
    name: "products-slug___ru",
    path: "/ru/products/:slug()",
    component: () => import("/usr/src/nuxt-app/pages/products/[slug].vue")
  },
  {
    name: "products-slug___es",
    path: "/es/products/:slug()",
    component: () => import("/usr/src/nuxt-app/pages/products/[slug].vue")
  },
  {
    name: "search-category___en",
    path: "/en/search/:category()",
    component: () => import("/usr/src/nuxt-app/pages/search/[category].vue")
  },
  {
    name: "search-category___zh-Hans",
    path: "/zh-Hans/search/:category()",
    component: () => import("/usr/src/nuxt-app/pages/search/[category].vue")
  },
  {
    name: "search-category___zh-Hant",
    path: "/zh-Hant/search/:category()",
    component: () => import("/usr/src/nuxt-app/pages/search/[category].vue")
  },
  {
    name: "search-category___fr",
    path: "/fr/search/:category()",
    component: () => import("/usr/src/nuxt-app/pages/search/[category].vue")
  },
  {
    name: "search-category___de",
    path: "/de/search/:category()",
    component: () => import("/usr/src/nuxt-app/pages/search/[category].vue")
  },
  {
    name: "search-category___it",
    path: "/it/search/:category()",
    component: () => import("/usr/src/nuxt-app/pages/search/[category].vue")
  },
  {
    name: "search-category___ja",
    path: "/ja/search/:category()",
    component: () => import("/usr/src/nuxt-app/pages/search/[category].vue")
  },
  {
    name: "search-category___ko",
    path: "/ko/search/:category()",
    component: () => import("/usr/src/nuxt-app/pages/search/[category].vue")
  },
  {
    name: "search-category___pt-BR",
    path: "/pt-BR/search/:category()",
    component: () => import("/usr/src/nuxt-app/pages/search/[category].vue")
  },
  {
    name: "search-category___ru",
    path: "/ru/search/:category()",
    component: () => import("/usr/src/nuxt-app/pages/search/[category].vue")
  },
  {
    name: "search-category___es",
    path: "/es/search/:category()",
    component: () => import("/usr/src/nuxt-app/pages/search/[category].vue")
  },
  {
    name: "unauthorized-access___en",
    path: "/en/unauthorized-access",
    component: () => import("/usr/src/nuxt-app/pages/unauthorized-access.vue")
  },
  {
    name: "unauthorized-access___zh-Hans",
    path: "/zh-Hans/unauthorized-access",
    component: () => import("/usr/src/nuxt-app/pages/unauthorized-access.vue")
  },
  {
    name: "unauthorized-access___zh-Hant",
    path: "/zh-Hant/unauthorized-access",
    component: () => import("/usr/src/nuxt-app/pages/unauthorized-access.vue")
  },
  {
    name: "unauthorized-access___fr",
    path: "/fr/unauthorized-access",
    component: () => import("/usr/src/nuxt-app/pages/unauthorized-access.vue")
  },
  {
    name: "unauthorized-access___de",
    path: "/de/unauthorized-access",
    component: () => import("/usr/src/nuxt-app/pages/unauthorized-access.vue")
  },
  {
    name: "unauthorized-access___it",
    path: "/it/unauthorized-access",
    component: () => import("/usr/src/nuxt-app/pages/unauthorized-access.vue")
  },
  {
    name: "unauthorized-access___ja",
    path: "/ja/unauthorized-access",
    component: () => import("/usr/src/nuxt-app/pages/unauthorized-access.vue")
  },
  {
    name: "unauthorized-access___ko",
    path: "/ko/unauthorized-access",
    component: () => import("/usr/src/nuxt-app/pages/unauthorized-access.vue")
  },
  {
    name: "unauthorized-access___pt-BR",
    path: "/pt-BR/unauthorized-access",
    component: () => import("/usr/src/nuxt-app/pages/unauthorized-access.vue")
  },
  {
    name: "unauthorized-access___ru",
    path: "/ru/unauthorized-access",
    component: () => import("/usr/src/nuxt-app/pages/unauthorized-access.vue")
  },
  {
    name: "unauthorized-access___es",
    path: "/es/unauthorized-access",
    component: () => import("/usr/src/nuxt-app/pages/unauthorized-access.vue")
  },
  {
    name: "unauthorized-region___en",
    path: "/en/unauthorized-region",
    component: () => import("/usr/src/nuxt-app/pages/unauthorized-region.vue")
  },
  {
    name: "unauthorized-region___zh-Hans",
    path: "/zh-Hans/unauthorized-region",
    component: () => import("/usr/src/nuxt-app/pages/unauthorized-region.vue")
  },
  {
    name: "unauthorized-region___zh-Hant",
    path: "/zh-Hant/unauthorized-region",
    component: () => import("/usr/src/nuxt-app/pages/unauthorized-region.vue")
  },
  {
    name: "unauthorized-region___fr",
    path: "/fr/unauthorized-region",
    component: () => import("/usr/src/nuxt-app/pages/unauthorized-region.vue")
  },
  {
    name: "unauthorized-region___de",
    path: "/de/unauthorized-region",
    component: () => import("/usr/src/nuxt-app/pages/unauthorized-region.vue")
  },
  {
    name: "unauthorized-region___it",
    path: "/it/unauthorized-region",
    component: () => import("/usr/src/nuxt-app/pages/unauthorized-region.vue")
  },
  {
    name: "unauthorized-region___ja",
    path: "/ja/unauthorized-region",
    component: () => import("/usr/src/nuxt-app/pages/unauthorized-region.vue")
  },
  {
    name: "unauthorized-region___ko",
    path: "/ko/unauthorized-region",
    component: () => import("/usr/src/nuxt-app/pages/unauthorized-region.vue")
  },
  {
    name: "unauthorized-region___pt-BR",
    path: "/pt-BR/unauthorized-region",
    component: () => import("/usr/src/nuxt-app/pages/unauthorized-region.vue")
  },
  {
    name: "unauthorized-region___ru",
    path: "/ru/unauthorized-region",
    component: () => import("/usr/src/nuxt-app/pages/unauthorized-region.vue")
  },
  {
    name: "unauthorized-region___es",
    path: "/es/unauthorized-region",
    component: () => import("/usr/src/nuxt-app/pages/unauthorized-region.vue")
  },
  {
    name: "preview-article-id___en",
    path: "/en/preview/article/:id()",
    meta: _91id_93uqLl8_djPb_45jS62wEZOXPz07L8h7nlt8zCTCBUT28IoMeta || {},
    component: () => import("/usr/src/nuxt-app/pages/preview/article/[id].vue")
  },
  {
    name: "preview-article-id___zh-Hans",
    path: "/zh-Hans/preview/article/:id()",
    meta: _91id_93uqLl8_djPb_45jS62wEZOXPz07L8h7nlt8zCTCBUT28IoMeta || {},
    component: () => import("/usr/src/nuxt-app/pages/preview/article/[id].vue")
  },
  {
    name: "preview-article-id___zh-Hant",
    path: "/zh-Hant/preview/article/:id()",
    meta: _91id_93uqLl8_djPb_45jS62wEZOXPz07L8h7nlt8zCTCBUT28IoMeta || {},
    component: () => import("/usr/src/nuxt-app/pages/preview/article/[id].vue")
  },
  {
    name: "preview-article-id___fr",
    path: "/fr/preview/article/:id()",
    meta: _91id_93uqLl8_djPb_45jS62wEZOXPz07L8h7nlt8zCTCBUT28IoMeta || {},
    component: () => import("/usr/src/nuxt-app/pages/preview/article/[id].vue")
  },
  {
    name: "preview-article-id___de",
    path: "/de/preview/article/:id()",
    meta: _91id_93uqLl8_djPb_45jS62wEZOXPz07L8h7nlt8zCTCBUT28IoMeta || {},
    component: () => import("/usr/src/nuxt-app/pages/preview/article/[id].vue")
  },
  {
    name: "preview-article-id___it",
    path: "/it/preview/article/:id()",
    meta: _91id_93uqLl8_djPb_45jS62wEZOXPz07L8h7nlt8zCTCBUT28IoMeta || {},
    component: () => import("/usr/src/nuxt-app/pages/preview/article/[id].vue")
  },
  {
    name: "preview-article-id___ja",
    path: "/ja/preview/article/:id()",
    meta: _91id_93uqLl8_djPb_45jS62wEZOXPz07L8h7nlt8zCTCBUT28IoMeta || {},
    component: () => import("/usr/src/nuxt-app/pages/preview/article/[id].vue")
  },
  {
    name: "preview-article-id___ko",
    path: "/ko/preview/article/:id()",
    meta: _91id_93uqLl8_djPb_45jS62wEZOXPz07L8h7nlt8zCTCBUT28IoMeta || {},
    component: () => import("/usr/src/nuxt-app/pages/preview/article/[id].vue")
  },
  {
    name: "preview-article-id___pt-BR",
    path: "/pt-BR/preview/article/:id()",
    meta: _91id_93uqLl8_djPb_45jS62wEZOXPz07L8h7nlt8zCTCBUT28IoMeta || {},
    component: () => import("/usr/src/nuxt-app/pages/preview/article/[id].vue")
  },
  {
    name: "preview-article-id___ru",
    path: "/ru/preview/article/:id()",
    meta: _91id_93uqLl8_djPb_45jS62wEZOXPz07L8h7nlt8zCTCBUT28IoMeta || {},
    component: () => import("/usr/src/nuxt-app/pages/preview/article/[id].vue")
  },
  {
    name: "preview-article-id___es",
    path: "/es/preview/article/:id()",
    meta: _91id_93uqLl8_djPb_45jS62wEZOXPz07L8h7nlt8zCTCBUT28IoMeta || {},
    component: () => import("/usr/src/nuxt-app/pages/preview/article/[id].vue")
  },
  {
    name: component_45stub5NatCyIcPyRWR_VP9IPrV2_7eD13VIAMdmbwNW3_454B8Meta?.name,
    path: "/en/sitemap.xml",
    component: component_45stub5NatCyIcPyRWR_VP9IPrV2_7eD13VIAMdmbwNW3_454B8
  },
  {
    name: component_45stub5NatCyIcPyRWR_VP9IPrV2_7eD13VIAMdmbwNW3_454B8Meta?.name,
    path: "/zh-Hans/sitemap.xml",
    component: component_45stub5NatCyIcPyRWR_VP9IPrV2_7eD13VIAMdmbwNW3_454B8
  },
  {
    name: component_45stub5NatCyIcPyRWR_VP9IPrV2_7eD13VIAMdmbwNW3_454B8Meta?.name,
    path: "/zh-Hant/sitemap.xml",
    component: component_45stub5NatCyIcPyRWR_VP9IPrV2_7eD13VIAMdmbwNW3_454B8
  },
  {
    name: component_45stub5NatCyIcPyRWR_VP9IPrV2_7eD13VIAMdmbwNW3_454B8Meta?.name,
    path: "/fr/sitemap.xml",
    component: component_45stub5NatCyIcPyRWR_VP9IPrV2_7eD13VIAMdmbwNW3_454B8
  },
  {
    name: component_45stub5NatCyIcPyRWR_VP9IPrV2_7eD13VIAMdmbwNW3_454B8Meta?.name,
    path: "/de/sitemap.xml",
    component: component_45stub5NatCyIcPyRWR_VP9IPrV2_7eD13VIAMdmbwNW3_454B8
  },
  {
    name: component_45stub5NatCyIcPyRWR_VP9IPrV2_7eD13VIAMdmbwNW3_454B8Meta?.name,
    path: "/it/sitemap.xml",
    component: component_45stub5NatCyIcPyRWR_VP9IPrV2_7eD13VIAMdmbwNW3_454B8
  },
  {
    name: component_45stub5NatCyIcPyRWR_VP9IPrV2_7eD13VIAMdmbwNW3_454B8Meta?.name,
    path: "/ja/sitemap.xml",
    component: component_45stub5NatCyIcPyRWR_VP9IPrV2_7eD13VIAMdmbwNW3_454B8
  },
  {
    name: component_45stub5NatCyIcPyRWR_VP9IPrV2_7eD13VIAMdmbwNW3_454B8Meta?.name,
    path: "/ko/sitemap.xml",
    component: component_45stub5NatCyIcPyRWR_VP9IPrV2_7eD13VIAMdmbwNW3_454B8
  },
  {
    name: component_45stub5NatCyIcPyRWR_VP9IPrV2_7eD13VIAMdmbwNW3_454B8Meta?.name,
    path: "/pt-BR/sitemap.xml",
    component: component_45stub5NatCyIcPyRWR_VP9IPrV2_7eD13VIAMdmbwNW3_454B8
  },
  {
    name: component_45stub5NatCyIcPyRWR_VP9IPrV2_7eD13VIAMdmbwNW3_454B8Meta?.name,
    path: "/ru/sitemap.xml",
    component: component_45stub5NatCyIcPyRWR_VP9IPrV2_7eD13VIAMdmbwNW3_454B8
  },
  {
    name: component_45stub5NatCyIcPyRWR_VP9IPrV2_7eD13VIAMdmbwNW3_454B8Meta?.name,
    path: "/es/sitemap.xml",
    component: component_45stub5NatCyIcPyRWR_VP9IPrV2_7eD13VIAMdmbwNW3_454B8
  }
]